import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { approveSpamAccountRoute, deleteAdminEmployerRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList, spamAccountList } from '../constants';

type useApproveSpamEmployerProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useApproveSpamEmployer = ({
    setAlertText = () => { },
}: useApproveSpamEmployerProps) => {
    const client = useQueryClient();

    const { mutate: approveSpamEmployer, isLoading: isApproveSpamEmployerLoading } =
        useMutation({
            mutationFn: (variables: {
                company_id: number | string;
            }) =>
                axiosInstance
                    .post(approveSpamAccountRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setAlertText(data.message);
                } else if (data.status === 200) {
                    client.invalidateQueries(adminEmployersList);
                    client.invalidateQueries(adminEnterprisesList);
                    client.invalidateQueries(spamAccountList);
                    setAlertText('');
                }
            },
            onError: () => {
                setAlertText(errorMessage);
            },
        });
    return {
        approveSpamEmployer,
        isApproveSpamEmployerLoading,
    };
};
